import React from "react";
import JournalEntryPage from "./AccountPage"; // your existing page
import AccountTree from "./AccountTree"; // tree component

import { Row, Col } from "react-bootstrap";

export default function JournalWithTree() {
  return (
       <Row>
        {/* Left side: Journal entries */}
        

        {/* Right side: Tree */}
        <Col md={3} className="border-start mt-3" style={{ maxHeight: "100vh", overflowY: "auto" }}>
          <AccountTree />
        </Col>
        <Col md={9}>
          <JournalEntryPage />
        </Col>
      </Row>
   );
}
